import { createFileRoute, Navigate, useNavigate } from '@tanstack/react-router';
import { IconSitemap } from '@tabler/icons-react';
import { MaePageHead, MaeShell } from '@/shared/desktop/MaeShell';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { WbsView } from '@/features/projects/wbs/WbsView';

interface WbsSearch {
  /** Il progetto la cui WBS e' aperta nell'editor; assente = l'elenco. */
  project?: string;
}

export const Route = createFileRoute('/_app/projects/wbs')({
  validateSearch: (s: Record<string, unknown>): WbsSearch => ({
    project: typeof s.project === 'string' && s.project ? s.project : undefined,
  }),
  component: WbsRoute,
});

/**
 * L'andamento WBS dei progetti, **da scrivania**.
 *
 * Sul telefono `ProjectWbsTree` ha gia' la sua resa dentro la scheda progetto: con un progetto
 * aperto si va li', altrimenti all'elenco dei progetti.
 */
function WbsRoute() {
  const isMobile = useIsMobileShell();
  const { project } = Route.useSearch();
  const navigate = useNavigate();

  if (isMobile) {
    return project
      ? <Navigate to="/projects/$projectId" params={{ projectId: project }} replace />
      : <Navigate to="/projects" replace />;
  }

  return (
    <MaeShell fullHeight>
      <MaePageHead
        title="Andamento WBS"
        sub="Avanzamento dei progetti e voci chiuse nel periodo"
        icon={<IconSitemap size={23} />}
      />
      <WbsView
        projectId={project ?? null}
        onOpenProject={(id) => void navigate({ to: '/projects/wbs', search: { project: id } })}
        onCloseProject={() => void navigate({ to: '/projects/wbs', search: {} })}
      />
    </MaeShell>
  );
}
